import React from "react";

export default function IntroCTR() {
    return (
        <div className="mt-12 md:mt-22">
            <h2 className="text-[#666] text-[30px] md:text-[44px] font-semibold">
                Dubai's Most Trusted Tour Operator
            </h2>
            <p className="text-[#999999] text-[16px] md:leading-relaxed mb-4">
                Where Every Adventure Begins
            </p>
            <p className="text-[#4E4E4E] md:text-[18px] md:leading-relaxed mb-8">
                From sunrise desert safaris to iconic city tours, Bonvoy Tourism creates experiences that stay with you long after you've left Dubai. 60+ five-star reviews. Best price guaranteed. Hotel pickup included.</p>
            <div className="flex flex-col md:flex-row gap-4 md:gap-22 items-center justify-between">
                <div
                    className="md:flex-1 w-full h-[318px] md:h-[418px] bg-cover bg-top rounded-md"
                    style={{ backgroundImage: "url('/images/home/h1.jpg')" }}
                ></div>
                <div className="flex-1">
                    <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-2">
                        Introduction
                    </h3>
                    <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
                        Dubai is unlike anywhere else on earth. One morning you can be racing across golden dunes in a 4×4 Land Cruiser, watching the desert sunrise paint the sky in shades of amber and rose. By evening, you can be sailing along the glittering Dubai Marina on a traditional wooden dhow with a plate of grilled Arabic food in front of you and the city skyline shimmering in the water below. That is what we do at Bonvoy Tourism — we bring the very best of Dubai to life for you.
                    </p>
                    <p className="text-[13px] text-[#606060] max-w-[730px] mb-4">
                        We are a Dubai-based tour operator specialising in desert safaris, city sightseeing, adventure activities and day trips across the UAE. Every tour we offer is personally curated, every guide we work with is hand-picked, and every vehicle in our fleet is fully licensed and insured. Whether you are visiting Dubai for three days or three weeks, travelling solo, as a couple, or with your whole family — we have the perfect experience waiting for you.
                    </p>
                    <p className="text-[13px] text-[#606060] max-w-[730px]">
                        With more than 60 verified five-star reviews and a 5.0 rating on TripAdvisor, Bonvoy Tourism is one of Dubai's most trusted tour operators. Our guides Rashid and Taj are mentioned by name in review after review for their warmth, local knowledge and exceptional photography skills. We don't just show you Dubai — we help you truly feel it.
                    </p>
                </div>
            </div>
        </div>
    );
}
